import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PaymentResource} from '../resource/payment.resource';

/**
 * DTO for creating a payment intent
 */
export interface CreatePaymentIntentDto {
  userId: string;
  packageId: string;
  billingInterval: 'monthly' | 'yearly';
}

export interface PaymentIntentResponse {
  clientSecret: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {

  constructor(private resource: PaymentResource) {}

  createPaymentIntent(dto: CreatePaymentIntentDto): Observable<PaymentIntentResponse> {
    return this.resource.createPaymentIntent(dto.userId, dto.packageId, dto.billingInterval);
  }

  getPaymentStatus(intentId: string): Observable<{ status: string }> {
    return this.resource.getPaymentStatus(intentId);
  }
  /**
   * Create a SetupIntent for saving a payment method
   */
  createSetupIntent(userId: string): Observable<{ clientSecret: string }> {
    return this.resource.createSetupIntent(userId);
  }
  /**
   * Create a new subscription on the server with a saved payment method
   */
  getPaymentMethod(): Observable<{ last4: string; expMonth: number; expYear: number; brand: string } | null> {
    return this.resource.getPaymentMethod();
  }

  updateCard(paymentMethodId: string): Observable<void> {
    return this.resource.updateCard(paymentMethodId);
  }

  getPaymentMethodLast4(pmId: string): Observable<{ last4: string }> {
    return this.resource.getPaymentMethodLast4(pmId);
  }

  createSubscription(
    userId: string,
    packageId: string,
    billingInterval: 'monthly' | 'yearly',
    paymentMethodId: string,
    billingName?: string
  ): Observable<{
    subscriptionId: string;
    clientSecret?: string;
    status?: string;
  }> {
    return this.resource.createSubscription(userId, packageId, billingInterval, paymentMethodId, billingName);
  }

}
